module.exports = __webpack_public_path__ + "img/icon_home.443191f7.png";